export default "__VITE_ASSET__CWZAqIMr__"